import {
  DataGridFilter,
  DataGridFilters,
  DataGridOptions,
} from "fe-shared/src/components/DataGrid/modules/types";

import {
  DataGridFiltersParams,
  DataGridRequestParams,
  GridTransactionList,
  GridTransaction,
  TransactionStatus,
} from "../types";
import { ADJUSTABLE_SUBMITTED_STATUS } from "./transactionsGridConfig";

export const PROPERTY_NAMES_MAP: { [key: string]: string } = {
  participants: "displayNameOrRegNumber",
  assignee: "assignedToName",
  carrier: "carrierName",
  transactionNumber: "transactionOrInvoiceNumber",
};

const getPropertyName = (name: string) => PROPERTY_NAMES_MAP[name] || name;

const getFilterValues = (filter: DataGridFilter) => {
  switch (filter.type) {
    case "dateRangeFilter": {
      const [startDate, endDate] = filter.value;

      if (startDate) {
        return [startDate, endDate || startDate]
          .map((date) => new Date(date).toJSON())
          .join(",");
      }
      return "";
    }
    case "selectFilter":
      if (filter.value.length) {
        return filter.value.join(",");
      }
      return "";
    default:
      return filter.value;
  }
};

export const getRequestParams = (
  filters: DataGridFilters,
  options: DataGridOptions
): DataGridRequestParams => {
  const filteringParameters = Object.keys(filters).reduce(
    (acc: DataGridFiltersParams[], property: string) => {
      const filter = filters[property];
      const values = getFilterValues(filter);
      const propertyName = getPropertyName(property);

      if (
        property === "statusCode" &&
        [ADJUSTABLE_SUBMITTED_STATUS, TransactionStatus.Submitted].includes(
          values
        )
      ) {
        acc.push(
          {
            propertyName,
            values: TransactionStatus.Submitted,
          },
          {
            propertyName: "isAdjustable",
            values: values === ADJUSTABLE_SUBMITTED_STATUS ? "true" : "false",
          }
        );
      } else if (property === "transactionNumber") {
        const currentNumber = values.replace(/[# ]/g, "");

        if (currentNumber) {
          acc.push({
            propertyName,
            values: currentNumber,
          });
        }
      } else if (values) {
        acc.push({
          propertyName,
          values,
        });
      }
      return acc;
    },
    []
  );

  return {
    filteringParameters,
    sortingBy: {
      propertyName: getPropertyName(options.sortField),
      isAscending: options.sortDirection === "asc",
    },
  };
};

export const getFlattenedTransactions = (
  data?: GridTransactionList<GridTransaction>[]
) =>
  data?.reduce(
    (acc: GridTransaction[], element: GridTransactionList<GridTransaction>) =>
      acc.concat(element.transactions),
    []
  );
